module.exports = __webpack_public_path__ + "static/media/14UNEP26.15a228b3.jpg";